import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from "classnames";
import { A11y, Autoplay, Navigation, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import { dispatchTrackingEvent, TrackingEvents } from "@jti/tracker";
import { Loader } from "../Loader/Loader";
import styles from "./SwiperJti.module.scss";
export { SwiperSlide };
export const SwiperJti = ({ children, mode = "light", rtl, swiperJtiClass, swiperJtiWrapper, isShowNavigationArrows = true, isShowPaginationButtons = true, isContainerWidth = false, isViewportHeight = true, isCustomPagination = false, handleSlideChange, showLoader = false, isOverflowEnabled = false, isAutoplayEnabled = false, autoplayDelay = 5000, ...props }) => {
    const swiperWrapperClasses = classNames(styles.swiperJtiWrapper, swiperJtiWrapper, {
        [styles.swiperJtiWrapperDark]: mode === "dark",
        [styles.swiperJtiWrapperRtl]: rtl,
        [styles.swiperJtiContainerWidth]: isContainerWidth,
        [styles.swiperJtiViewPortHeight]: isViewportHeight,
        [styles.swiperJtiCustomPagination]: isCustomPagination,
        [styles.swiperJtiNotViewPortHeight]: !isViewportHeight,
        [styles.swiperJtiWithLoader]: showLoader,
        [styles.swiperJtiOverflowVisible]: isOverflowEnabled,
    });
    const handleLinkClick = () => {
        dispatchTrackingEvent(TrackingEvents.TrackingCarouselClick);
    };
    return (_jsxs("div", { className: swiperWrapperClasses, dir: rtl ? "rtl" : "", "data-testid": "swiper-jti", children: [showLoader && _jsx(Loader, {}), _jsx(Swiper, { className: swiperJtiClass, modules: [Navigation, Pagination, A11y, Autoplay], pagination: isShowPaginationButtons ? { clickable: true } : false, navigation: isShowNavigationArrows, onTransitionEnd: handleLinkClick, touchStartPreventDefault: false, onSlideChange: handleSlideChange, autoplay: isAutoplayEnabled ? { delay: autoplayDelay, disableOnInteraction: false } : false, ...props, children: children })] }));
};
//# sourceMappingURL=SwiperJti.js.map